import { loadUserAlertsFailed, loadUserAlertsSucceeded } from './actionCreators';
import type { LoadAlertsRequest } from './actions';
import { ActionTypes } from './actionTypes';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import type { PageableContent } from '@cobliteam/common-types';

import { GraphQLUserAlertRequester, type UserAlert } from '@cobliteam/api-lib';

import Alert from '@cobliteam/ui/components/Alert';

export const graphQLUserAlertRequester: GraphQLUserAlertRequester = new GraphQLUserAlertRequester();

export function* requestLoadAlertSaga(action: LoadAlertsRequest) {
  const { period, page, size, filters, sort } = action.payload;

  try {
    const alertsPage: PageableContent<UserAlert> = yield call(graphQLUserAlertRequester.getAlerts, period, page, size, filters, sort);

    yield put(loadUserAlertsSucceeded(alertsPage));
  } catch (err) {
    yield put(loadUserAlertsFailed());
    Alert.error('Houve um erro, tente novamente mais tarde.');
  }
}

export function* UserAlertsSagasListener() {
  yield all([takeLatest(ActionTypes.LOAD_ALERT_REQUEST, requestLoadAlertSaga)]);
}
